import { render, staticRenderFns } from "./trade-banner.vue?vue&type=template&id=15531890&scoped=true"
import script from "./trade-banner.vue?vue&type=script&lang=js"
export * from "./trade-banner.vue?vue&type=script&lang=js"
import style0 from "./trade-banner.vue?vue&type=style&index=0&id=15531890&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15531890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15531890')) {
      api.createRecord('15531890', component.options)
    } else {
      api.reload('15531890', component.options)
    }
    module.hot.accept("./trade-banner.vue?vue&type=template&id=15531890&scoped=true", function () {
      api.rerender('15531890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade/trade-banner.vue"
export default component.exports